import React from 'react'
import { Button } from '@alifd/next'
import styles from './index.module.scss'
import ServiceAnimate from './ServiceAnimate/ServiceAnimate'

export default function DataService() {
  return (
    <React.Fragment>
      {/* 临床研究大数据服务 */}
      <div style={{ width: '100%', background: '#f9fbff'}}>
        <div className={ styles.dataService }>
          <h2>临床研究大数据服务<p></p></h2>
          <div className={styles.service}>临床研究大数据服务平台能够实现临床研究数据采集、存储、抽取、清洗、转换、分析和开发应用过程的全覆盖，统筹呼吸领域最具优势的人群研究资源、专病队列资源及诊疗研究协同网络资源</div>
          <div className={ styles.btn }>
            <a href="/exteriorFacade" target="_blank" rel="noopener noreferrer">
              <Button style={{ width: 132, height: 42, fontSize: 14, padding: 0 }}>开始探索</Button>
            </a>
          </div>
          <ServiceAnimate />
        </div>
      </div>
    </React.Fragment>
  )
}
